import { render, staticRenderFns } from "./ReportDesktopMoreEmployees.vue?vue&type=template&id=45a534e6"
import script from "./ReportDesktopMoreEmployees.vue?vue&type=script&lang=js"
export * from "./ReportDesktopMoreEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports